import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, Accordion } from "react-bootstrap";

const Servicios = () => {
  return (
    <div >
      <Helmet>
        <title>Nuestros servicios | Manacars</title>
        <meta name="description" content="Compraventa, financiación, tasación y garantía de 12 meses. Todo lo que necesitas para tu próximo coche en Manacars." />
        <link rel="canonical" href="https://manacars.es/servicios" />
      </Helmet>
      <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
    />
      <div className="containerS pruebaServicios">
        <h1>Servicios</h1>
        <p className='serviciostext1'>Además de la compraventa de vehículos, en Manacars ofrecemos: financiación a medida para tu próximo coche, tasación gratuita de tu vehículo actual, garantía de 12 meses en todos nuestros vehículos de ocasión y km 0, y entrega en toda España.</p>
        <div className="row">
            <div className="service">
            <i className="fas fa-money-check-alt"></i>
            <h2>FINANCIACIÓN A MEDIDA</h2>
            <p>
            Proporcionamos opciones de financiación hechas a medida, pensadas para adaptarse a tus necesidades. 
            Facilitamos procesos flexibles y tasas competitivas, permitiéndote adquirir tu coche ideal de forma cómoda y segura.
            </p>
          </div>
          <div className="service">
            <i className="fas fa-chart-line"></i>
            <h2>TASACIÓN GRATUITA</h2>
            <p>
            Nuestro servicio de tasación evalúa detalladamente tu vehículo para ofrecerte el mejor precio posible. 
            En 24 horas recibirás la tasación en tu correo.
            </p>
          </div>
          <div className="service">
            <i className="fas fa-award"></i>
            <h2>GARANTIA DE 12 MESES</h2>
            <p>
            Todos nuestros vehículos incluyen una garantía estándar de 12 meses. 
            Además, puedes optar por ampliar esta garantía para disfrutar de mayor tranquilidad y protección a largo plazo. Consulta las condiciones.
            </p>
          </div>
          <div className="service">
            <i className="fas fa-car"></i>
            <h2>ENTREGA EN TODA ESPAÑA</h2>
            <p>
            Nos aseguramos de que tu nuevo coche llegue a donde estés. 
            Ofrecemos un servicio de entrega a cualquier parte de España, garantizando que recibas tu vehículo de manera rápida y segura.
            </p>
          </div>
        </div>
      </div>
      <div>
      <Accordion className="acord-about" defaultActiveKey="1">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <Card.Title className="title-act-1"> ¿Aceptáis vehículos cómo parte de pago?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card>
              <Card.Body>
                <Card.Text>
                  Sí, en Manacars aceptamos vehículos como parte de pago. Para decidir si aceptamos un vehículo o no, realizamos una evaluación detallada del coche que se ofrece en parte de pago,
                   considerando factores como el año, el kilometraje, el estado general y el historial de mantenimiento, asegurando así un acuerdo justo y transparente para ambas partes.
                </Card.Text>
              </Card.Body>
            </Card>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Accordion className="acord-about" defaultActiveKey="1">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <Card.Title className="title-act-1"> Me gusta un coche, ¿Cómo lo puedo reservar?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card>
              <Card.Body>
                <Card.Text>
                  <div className="body-card-about">
                    Selecciona el vehículo que te gusta, pulsa en el botón "Reservar Vehículo" y sigue los pasos. ¡Así de fácil!
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Accordion className="acord-about" defaultActiveKey="1">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <Card.Title className="title-act-1">¿Qué cubren las garantías de nuestros vehículos?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card>
              <Card.Body>
                <Card.Text>
                  <div className="body-card-about">
                  La garantía que ofrecemos es de 1 año respetando la legislación vigente. Además, ofrecemos la posibilidad de contratar una ampliación de coberturas de hasta 3 años.
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>


      <Accordion className="acord-about" defaultActiveKey="1">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <Card.Title className="title-act-1">¿Qué control de calidad pasan nuestros vehículos?</Card.Title>
          </Accordion.Header>
          <Accordion.Body>
            <Card>
              <Card.Body>
                <Card.Text>
                  <div className="body-card-about">
                  En Manacars, cada vehículo es sometido a un exhaustivo control de calidad para garantizar su fiabilidad y seguridad. Este proceso incluye: Inspección Mecánica Completa, Revisión Estética y Funcional, Pruebas de Rendimiento en Carretera y Control de Calidad Final.                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
    </div>
  )
}

export default Servicios
